import React, { useEffect, useState } from 'react';
import { Container, Typography, List, ListItem, ListItemText, Stack } from '@mui/material';
import parse from 'html-react-parser';
import { HtmlRegex } from 'shared/constants';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../helpers/hooks';
import { ResourceElementsBorderRadius, ResourceTitleStack } from './Resources.styled';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { ShButton } from 'shared/SharedStyles/ShInputs';
import { useNotification } from 'Components/Notification';
import { Notification } from 'Components/Notification';

export const AiJobDescriptionPage = () => {
    const navigate = useNavigate();
    const { aiJobDescription } = useAppSelector(state => state.app.resources);
    const notification = useNotification();
    const [copiedToClipboard, setCopiedToClipboard] = useState(false);

    useEffect(() => {
        if (!aiJobDescription) {
            navigate('/resources');
        }
    }, [aiJobDescription, navigate]);


    const formatJobDescription = (jobDescription: string) => {
        const lines = jobDescription.split('\n');
    
        return lines.map((line, index) => {
            const isHeading = line.includes(':');
            const isListElement = /^\d+\./.test(line.trim()) || line.trim().includes('-');
    
            return isHeading ? (
                <Typography key={index} variant="body1" fontWeight={'bold'}>
                    {line}
                </Typography>
            ) : isListElement ? (
                <ListItem key={index} dense sx={{ listStyleType: 'disc' }}>
                    <ListItemText primary={line.replace(/^-|\d+\./, '•')} />
                </ListItem>
            ) : (
                <List key={index} dense>
                    <ListItemText primary={line} />
                </List>
            );
        });
    };

    useEffect(() => {
        if (copiedToClipboard) {
            notification.displayNotification({
                open: true,
                type: 'success',
                message: 'Successfully Copied!'
            });
            setCopiedToClipboard(false); 
        }
    }, [copiedToClipboard, notification]);


    const handleCopyAllClick = () => {
        navigator.clipboard.writeText(aiJobDescription ?? '')
            .then(() => {
                setCopiedToClipboard(true);
            })
    };

    return (
        <Container maxWidth='lg'>
            <ResourceTitleStack columnGap={1} rowGap={1}/>
            <ShPaper variant='outlined' borderRadius={ResourceElementsBorderRadius}>
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='right' paddingLeft={1} paddingBottom={1}  paddingTop={2}>
                    <ShButton color='success' href="https://app.smoothhiring.com/employers/new">
                        <BookmarkAddIcon />
                        <Typography variant="body2">Post This Job to 100+ Boards Instantly!</Typography>
                    </ShButton>
                    <ShButton color='primary' onClick={handleCopyAllClick}>
                        <CopyAllIcon />
                        <Typography variant="body2">Copy</Typography>
                    </ShButton>
                </Stack>
                <Container>
                    {HtmlRegex.test(aiJobDescription ?? '') ? (
                        parse(aiJobDescription ?? '')
                    ) : (
                        formatJobDescription(aiJobDescription)
                    )}
                </Container>
            </ShPaper>
            <Notification/>
        </Container>
    );
}

export default AiJobDescriptionPage;
